import "../../src/Components/Contacto/styles.less";

import { Col, Row } from "antd";
import React, { useEffect } from "react";
import {
	SectionFAQs,
	SectionForm,
	SectionHelp,
	SectionInfo,
} from "../../src/Components/Contacto/components";

import { PageLayout } from "../../src/Components/Layout/web";
import { useContact } from "../../src/Components/Contacto/hook";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { withApollo } from "../../lib/apollo3";
import { withAuth } from "../../lib/auth";
import { withContext } from "../../lib/context";
import { withGlobalComponents } from "../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../shared-components/i18n";

// Contacto
const Contacto = () => {
	const FP = useFacebookPixel();
	const {
		form,
		submitForm,
		validateRules,
		validateMessages,
		loading: { loading },
		formCompleted: { formCompleted },
		data: { dataSectionHelp, dataSectionFAQs },
	} = useContact();

	useEffect(() => {
		if (formCompleted) {
			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	// Components
	const COMPONENT_CONTACTS = [
		{
			id: 1,
			name: "info",
			render: <SectionInfo />,
		},
		{
			id: 2,
			name: "help",
			render: <SectionHelp dataSectionHelp={dataSectionHelp} />,
		},
		{
			id: 3,
			name: "form",
			render: (
				<SectionForm
					form={form}
					validateMessages={validateMessages}
					validateRules={validateRules}
					loading={loading}
					submitForm={submitForm}
				/>
			),
		},
		{
			id: 4,
			name: "FAQs",
			render: <SectionFAQs dataSectionFAQs={dataSectionFAQs} />,
		},
	];

	return (
		<PageLayout classContainer="contacto">
			<Row>
				{COMPONENT_CONTACTS.map(component => (
					<Col key={component.id} span={24} className={`section-${component.name}`}>
						<div className="container">{component.render}</div>
					</Col>
				))}
			</Row>
		</PageLayout>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(Contacto))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
